import { render, staticRenderFns } from "./activateDialog.vue?vue&type=template&id=ff979ec4&scoped=true&"
import script from "./activateDialog.vue?vue&type=script&lang=js&"
export * from "./activateDialog.vue?vue&type=script&lang=js&"
import style0 from "./activateDialog.vue?vue&type=style&index=0&id=ff979ec4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff979ec4",
  null
  
)

export default component.exports